<template lang="pug">
	.section
		.section__title(v-text="title" data-aos="fade-up")
		.categories(v-if="categories && categories.length" data-aos="fade-up" data-aos-delay="200")
			.categories__row
				.categories__item(v-for="(card, index) in categories" :key="index")
					router-link.categories__btn(:style="{backgroundColor: $route.params.category === card.slug ? card.color : '#fff'}" v-text="card.name" :to="'/products/' + card.slug + '/'" :class="['categories__btn_' + card.slug, $route.params.category === card.slug ? 'categories__btn_active' : '']")
		.categories.categories_mobile(v-if="categories && categories.length" data-aos="fade-up" data-aos-delay="200")
			block-select(:name="''" :label="'name'" :options="categories" @input="onChange" :selected="$route.params.category ? getCategoryBySlug($route.params.category) : ''")
		.categories.categories_mobile.categories_fixed(ref="categories_fixed" v-if="categories && categories.length")
			block-select(:name="''" :label="'name'" :options="categories" @input="onChange" :selected="$route.params.category ? getCategoryBySlug($route.params.category) : ''")
		.section__list(v-if="type === 'field_new'" data-aos="fade-up" data-aos-delay="500")
			section-card-field(
				v-for="(card, index) in list"
				:key="index"
				:card="card"
				:type="type"
				:link="link + card.slug + '/'"
			)
		.section__list(v-else data-aos="fade-up" data-aos-delay="500")
			section-card(
				v-for="(card, index) in list"
				:key="index"
				:card="card"
				:type="type"
				:link="link + card.slug + '/'"
			)
</template>

<script>

	import sectionCard from '@/components/sectionCard.vue';
	import sectionCardField from '@/components/sectionCardField.vue';

	import BlockSelect from '@/components/select.vue';
	import { mapGetters } from 'vuex';

	export default {
		name: 'ListSection',
		props: {
			title: String,
			list: Array,
			type: String,
			categories: Array,
			link: String
		},
		data: function(){
			return {

			}
		},
		methods: {
      onChange(e) {
        if (e.slug != this.$route.params.category) {
          this.$router.push({path: ('/products/' + e.slug + '/')})
        }
      },
    },
		computed: {
			...mapGetters([
				'getCategoryBySlug'
			])
		},
		components: {
			'section-card': sectionCard,
			'section-card-field': sectionCardField,
			'block-select': BlockSelect
		}
	}

</script>

<style lang="scss" scoped>

	@import '@/helpers/sass/kit.scss';

	.section {
		&__title {
			@include kit('sectionTitle');
		}

		&__list {
			margin: 36px -10px 44px;
		}
	}
	
	.categories {
		display: table;
		width: calc(100% + 20px);
		table-layout: fixed;
		margin-left: -10px;
		margin-top: 66px;
		margin-bottom: 50px;

		&_mobile {
			display: none;
		}

		&__row {
			display: table-row;
		}

		&__item {
			display: table-cell;
			width: 100%;
			text-align: center;
			padding: 0 5px;
		}

		&__btn {
			display: inline-block;
			vertical-align: top;
			height: 50px;
			background-color: #fff;
			width: 100%;
			font: 18px/52px Arial, sans-serif;
			letter-spacing: 1px;
			transition: background-color .5s ease, color .5s ease;
			outline: none;
			margin: 0;

			&_active {
				
				&.categories__btn_gerbicidi {
					background-color: #4D7860;
				}

				&.categories__btn_insekticidi {
					background-color: #DF7C2F;
				}

				color: #fff;
				// font-weight: 500;
			}
		}
	}

	@media screen and (max-width: 1200px) {
		.section {
			&__list {
				margin: 30px 0 40px;
			}
		}

		.categories {
			display: none;

			&_mobile {
				display: block;
				margin-top: 50px;
				width: 100%;
				margin-left: 0;
			}

			&_fixed {
				position: fixed;
				top: 100px;
				left: 0;
				width: 100%;
				z-index: 2;
				margin-top: 0;
				margin-left: 0;
				padding: 0 20px;
				opacity: 0;
				visibility: hidden;
				pointer-events: none;
				transition: opacity .5s ease, visibility .5s ease;

				&.active {
					opacity: 1;
					visibility: visible;
					pointer-events: all;
				}
			}
		}
	}
</style>
